













































































import { Vue, Component, Watch } from 'vue-property-decorator';
import request from '@/utils/request';
import moment from 'moment';
import AMSTable from '@/components/AMSTable.vue';
import Utils from '@/utils/utils';
import { getCustomer, getLogs } from '@/api/customer';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSOperateLogs from '@/components/AMSOperateLogs.vue';
@Component({
  components: {
    'ams-table': AMSTable,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-operate-logs': AMSOperateLogs
  }
})
export default class CustomerDetails extends Vue {
  breadItems = [
    {
      text: '客户管理',
      disabled: false,
      href: '/customer'
    },
    {
      text: '客户列表',
      disabled: false,
      href: '/customer'
    },
    {
      text: '客户详情',
      disabled: true
    }
  ];
  discounts: Array<any> = [];
  recordList: Array<any> = [];
  customer: any = {};

  get canEdit () {
    return Utils.isPermission('CustomerManager.CustomerList.CreateOrEdit')
  }

  formatDate(date: any) {
    return moment(date).format('YYYY-MM-DD');
  }

  parseArray(list: Array<object>) {
    if (!list || list.length < 1) return '';
    return list
      .map((l: any) => {
        return l.staff.name;
      })
      .join(',');
  }
  created() {
    let customerId = this.$route.query.id.toString();
    if (customerId) {
      this.getDetails(customerId);
      this.getoperationReacord(customerId);
    }
  }
  // 详情
  getDetails(id: string) {
    getCustomer(id.toString()).then((data: any) => {
      this.customer = data;
      this.discounts = data.productCategoryDicounts.concat(data.porductDiscounts);
    });
  }
  // 操作记录
  getoperationReacord(id: string) {
    getLogs(id.toString()).then((data: any) => {
      this.recordList = data.items;
    });
  }

  discountHeaders = [
    {
      text: '商品分类',
      value: 'productId',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        return h('div', param.row.productCategory && param.row.productCategory.name);
      }
    },
    {
      text: '商品',
      value: 'name',
      align: 'left',
      sortable: false,
      render: (h: Function, param: any) => {
        return h('div', param.row.product && param.row.product.name);
      }
    },
    {
      text: '折扣价',
      align: 'left',
      value: 'dicountPrice',
      sortable: false,
      render: (h: Function, param: any) => {
        return h('div', param.row.discountRate ? param.row.discountRate + '%' : Utils.formatCurrencyPrice(param.row.discountPrice));
      }
    }
  ];
  addressHeaders = [
    { text: '收货人', value: 'name', sortable: false, align: 'left' },
    {
      text: '联系电话',
      align: 'left',
      value: 'phone',
      sortable: false
    },
    {
      text: '地址',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        return h('div', param.row.region && param.row.region.fullName + param.row.address);
      }
    },
    {
      text: '设为默认',
      value: 'isDefault',
      align: 'left',
      sortable: false,
      render: (h: Function, param: any) => {
        return h('div', param.row[param.keyName] ? '是' : '否');
      }
    }
  ];
  records = [
    { text: '操作者', value: 'operator', sortable: false, align: 'left' },
    { text: '操作时间', value: 'operateTime', isFormatDate: true, sortable: false, align: 'left' },
    { text: '操作类型', value: 'operateType', sortable: false, align: 'left' },
    {
      text: '说明',
      value: 'propetyChanges',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        // let content = param.row[param.keyName].map((i: any) => {
        //   return h('span', ` ${i.propertyName} : 修改前 ${i.originalValue},修改后 ${i.newValue}   `);
        // });
        // return h('div', content);
        let content = ''
        param.row[param.keyName].forEach((i: any) => {
          content += `原 ${i.propertyName} 由 <span style="color:#00a679">${i.originalValue?i.originalValue:'空'}</span> 
          修改为 <span style="color:red">${i.newValue?i.newValue:'空'}</span>`
          content += '<br />'
        });
        return h('div', {
          domProps: {
            innerHTML: content
          }
        });
      }
    }
  ];

  get totalDiscount() {
    return this.discounts.length;
  }
  get totalAddress() {
    return this.customer.deliveryAddresses && this.customer.deliveryAddresses.length;
  }
  formatPrice(num: number) {
    return Utils.formatCurrencyPrice(num);
  }
  back() {
    this.$router.push({ name: 'customer_index' });
  }
  edit() {
    this.$router.push({ name: 'customer_edit', query: { id: this.$route.query.id } });
  }
}
